import { render, staticRenderFns } from "./OpenaiSummarise.vue?vue&type=template&id=cc7c91c2"
import script from "./OpenaiSummarise.vue?vue&type=script&lang=js"
export * from "./OpenaiSummarise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports